import { TRuleSources } from 'meta/rule_sources'

const rule_sources = {
  BATTLETOME_SERAPHON: {
    name: 'Battletome: Seraphon',
    type: 'battletome',
  },
} satisfies TRuleSources

export default rule_sources
